import { IAppAction } from "../appAction";
import { videoActions } from "./video-action";
import { getDefaultVideoState, IVideoState } from "./video-state";

const handlers = {
  [videoActions.REPORT_GIF_BY_ID]: (
    state: IVideoState
  ): IVideoState => {
    return { ...state, loading: true };
  },
  [videoActions.REPORT_GIF_BY_ID_SUCCESS]: (
    state: IVideoState,
  ): IVideoState => {
    return { ...state };
  },
  [videoActions.REPORT_GIF_BY_ID_ERROR]: (
    state: IVideoState,
    error: Error
  ): IVideoState => {
    return { ...state };
  },
  [videoActions.ADD_TO_QUEUE]: (
    state: IVideoState,
    payload: string
  ): IVideoState => {
    return {
      ...state,
      videoQueue: state.videoQueue.includes(payload) ? state.videoQueue : [...state.videoQueue, payload],
    };
  },
  [videoActions.REMOVE_FROM_QUEUE]: (
    state: IVideoState,
    payload: string
  ): IVideoState => {
    return {
      ...state,
      videoQueue: state.videoQueue.filter(id => id !== payload),
    };
  },
};

const videoReducer = (
  state: IVideoState = getDefaultVideoState(),
  action: IAppAction
) => {
  return Object.prototype.hasOwnProperty.call(handlers, action.type) ?
    handlers[action.type](state, action.payload) :
    state;
};

export default videoReducer;
